// const apiURL = process.env.REACT_APP_API_URL;
// const wsURL = process.env.REACT_APP_WS_URL;
// export const BASE_API = apiURL;
// export const WS_BASE_API = wsURL;
// export const DOMAIN = process.env.REACT_APP_URL;

// export const DOMAIN = 'http://127.0.0.1:8005';
// export const BASE_API = 'http://127.0.0.1:8005/api/';
// export const WS_BASE_API = 'WS://127.0.0.1:8005/ws/';

export const DOMAIN = process.env.REACT_APP_URL;
export const BASE_API = process.env.REACT_APP_API_URL;
export const WS_BASE_API = process.env.REACT_APP_WS_URL;

// export const BASE_API = 'http://45.149.78.217/api/';
// export const BASE_API = 'http://abshodeh.tabangohar.com/api/';
// export const BASE_API = 'https://abshodeh-test.tabangohar.com/api/';
// export const WS_BASE_API = 'WSS://abshodeh-test.tabangohar.com/ws/';
// export const BASE_API = 'https://abshodeh.tabangohar.com/api/';
// export const WS_BASE_API = 'WSS://abshodeh.tabangohar.com/ws/';
// export const DOMAIN = 'https://t1.tabangohar.com';
// export const BASE_API = 'https://t1.tabangohar.com/api/';
// export const WS_BASE_API = 'WSS://t1.tabangohar.com/ws/';
// export const DOMAIN = 'https://t2.tabangohar.com';
// export const BASE_API = 'https://t2.tabangohar.com/api/';
// export const WS_BASE_API = 'WSS://t2.tabangohar.com/ws/';
// export const DOMAIN = 'https://t4.tabangohar.com';
// export const BASE_API = 'https://t4.tabangohar.com/api/';
// export const WS_BASE_API = 'WSS://t4.tabangohar.com/ws/';
// export const DOMAIN = 'https://ma.hamkartala.ir';
// export const BASE_API = 'https://ma.hamkartala.ir/api/';
// export const WS_BASE_API = 'WSS://ma.hamkartala.ir/ws/';
// export const DOMAIN = 'https://hamkartala.ir';
// export const BASE_API = 'https://hamkartala.ir/api/';
// export const WS_BASE_API = 'WSS://hamkartala.ir/ws/';
// export const DOMAIN = 'https://farvardingold.ir';
// export const BASE_API = 'https://farvardingold.ir/api/';
// export const WS_BASE_API = 'WSS://farvardingold.ir/ws/';
// export const DOMAIN = 'https://yazd.farvardingold.ir';
// export const BASE_API = 'https://yazd.farvardingold.ir/api/';
// export const WS_BASE_API = 'WSS://yazd.farvardingold.ir/ws/';
export const OTP_EXPIRATION_API = `${BASE_API}otp/expiration/`;
export const AUTH_CHALLENGE_API = `${BASE_API}auth/challenge/`;
export const TGN_API_URL = `${BASE_API}tgn-gold-prices/`;
export const CHANGE_PASSWORD_API = `${BASE_API}change-password/`;
export const RESET_PASSWORD_API = `${BASE_API}reset-password/`;
export const MAIN_QUANTITY_API  = `${BASE_API}main-quantities/`;
export const QUANTITY_DEFINITION_API  = `${BASE_API}quantity-definitions/`;
export const PARENT_QUANTITY_DEFINITION_API  = `${BASE_API}parent-quantity-definitions/`;
export const QUANTITY_DEFINITION_UNIT_API  = `${BASE_API}quantity-definition-units/`;
export const QUANTITY_DEFINITION_COMMISSION_UNIT_API  = `${BASE_API}quantity-definition-commission-units/`;
export const QUANTITY_DEFINITION_CATEGORY_API  = `${BASE_API}quantity-definition-categories/`;
export const EXTERNAL_QUANTITY_DEFINITION_CATEGORY_API  = `${BASE_API}external-quantity-definition-categories/`;
export const EXTERNAL_QUANTITY_DEFINITION_API  = `${BASE_API}external-quantity-definitions/`;
export const QUANTITY_DEFINITION_MAPPING_API = `${BASE_API}quantity-definition-mappings/`
export const TRANSACTION_TYPE_API_URL = `${BASE_API}transaction-types/`;
export const GOLD_TRANSFER_TRANSACTION_TYPE_API_URL = `${BASE_API}gold-transfer-transaction-types/`;
export const GOLD_TYPE_API = `${BASE_API}gold-types/`;
export const GOLD_PRICE_API = `${BASE_API}gold-prices/`;
export const LAST_GOLD_PRICE_API = `${BASE_API}v2/last-gold-prices/`;
export const PARENT_GOLD_PRICE_API = `${BASE_API}v2/parent-gold-prices/`;
export const BULK_CREATE_LAST_GOLD_PRICES_API = `${BASE_API}v2/bulk-create-last-gold-prices/`;
export const BULK_CREATE_PARENT_GOLD_PRICES_API = `${BASE_API}v2/bulk-create-parent-gold-prices/`;

export const GOLD_PRICE_ACTIVENESS_HISTORY_API = `${BASE_API}gold-price-activenesses/`;
export const GOLD_PRICE_TYPE_API = `${BASE_API}gold-price-types/`;
export const GOLD_PRICE_IS_ACTIVE_API = `${BASE_API}gold-price-is-active/`;
export const GOLD_PRICE_STEP_API = `${BASE_API}gold-price-steps/`;
export const ACCOUNT_BALANCE_API = `${BASE_API}account-balances/`;
export const REAL_ASSET_API = `${BASE_API}real-assets/`;
export const CREDIT_API_URL = `${BASE_API}credits/`;
export const WALLET_API_URL = `${BASE_API}wallets/`;
export const TRANSACTION_EXPIRATIONS = `${BASE_API}transaction-expirations/`;
export const TRANSACTION_API_URL = `${BASE_API}transactions/`;
export const SEND_TRANSACTION_TO_SOURCE_API = `${BASE_API}send-transaction-to-source/`;
export const TRANSACTION_FIELD_VISIBILITY_API_URL = `${BASE_API}transaction-field-visibilities/`; 
export const ONLINE_ORDER_API_URL = `${BASE_API}online-orders/`;
export const IN_CALL_ORDER_API_URL = `${BASE_API}in-call-orders/`;
export const IN_PERSON_ORDER_API_URL = `${BASE_API}in-person-orders/`;
export const RECEIVE_OR_DELIVER_ORDER_API_URL = `${BASE_API}receive-or-deliver-orders/`;
export const TRANSACTION_ORDER_TYPE_API_URL = `${BASE_API}transaction-order-types/`;
export const NOTIFICATION_API_URL = `${BASE_API}notifications/`;
export const RECEIPT_API_URL = `${BASE_API}receipts/`;
export const CAPTCHA_API = `${BASE_API}captchas/`;
export const PORIFILES_API = `${BASE_API}profiles/`;
export const REORDER_DATA_API = `${BASE_API}reorder/`;
export const TREE_DATA_API = `${BASE_API}tree-data`;
export const ADMIN_MESSAGE_API = `${BASE_API}manager-messages/`;

export const OFFLINE_MODE_API = `${BASE_API}offline-modes/`;
export const GOLD_CREDIT_API = `${BASE_API}gold-credits/`;
export const GOLD_DATA_SOURCE_API = `${BASE_API}gold-data-sources/`;
export const GOLD_DATA_SOURCE_TOKEN_API = `${BASE_API}gold-data-source-tokens/`;
export const PARTNER_API = `${BASE_API}partners/`;
export const PARTNER_TOKEN_API = `${BASE_API}partner-tokens/`;
export const PARTNER_PRICE_MARKUP_API = `${BASE_API}partner-price-markups/`;
export const PRICE_MARKUP_API = `${BASE_API}price-markups/`;
export const PRICE_MARKUP_GROUP_API = `${BASE_API}price-markup-groups/`;
export const PRICE_MARKUP_TYPE_API = `${BASE_API}price-markup-types/`;
export const PRICE_MARKUP_CHANGE_TYPE_API = `${BASE_API}price-markup-change-types/`;
export const GOLD_PRICE_ROUNDING_API = `${BASE_API}gold-price-roundings/`;
export const WS_ADMIN_MESSAGE_API = `${WS_BASE_API}manager-messages/`;
export const WS_OFFLINE_MODE_API = `${WS_BASE_API}offline-mode/`;
export const USER_API = `${BASE_API}users/`;
export const USER_TOKEN_API = `${BASE_API}user-tokens/`;
export const USER_TOKEN_EXPIRE_TYPE_API = `${BASE_API}user-token-expire-types/`;
export const AUTO_SEND_TRANSACTION_API = `${BASE_API}auto-send-transactions/`;
export const GEO_AREA_API = `${BASE_API}geo-areas/`;
export const SITE_SETTINGS_API = `${BASE_API}site-settings/`;
export const LOGIN_SETTINGS_API = `${BASE_API}login-settings/`;

export const CURRENT_TIME_API = `${BASE_API}current-time/`;
export const PROFILE_TRADING_CONFIG_API = `${BASE_API}profile-trading-configs/`;
export const COMMISSION_TRADING_CONFIG_API = `${BASE_API}commission-trading-config/`;
export const COMMISSION_TRADING_CONFIG_HISTORIES_API = `${BASE_API}commission-trading-config-histories/`;
export const PROFILE_TRADING_CONFIG_HISTORIES_API = `${BASE_API}profile-trading-config-histories/`;
export const ACTIVE_USERS_API = `${BASE_API}active-users/`;
export const PRICING_SNAPSHOT_API = `${BASE_API}pricing/snapshot/`;
export const USER_PRICING_SNAPSHOT_API = `${BASE_API}user/pricing/snapshot/`;
export const PRICING_SNAPSHOT_API_V2 = `${BASE_API}v2/pricing/snapshot/`;
export const USER_PRICING_SNAPSHOT_API_V2 = `${BASE_API}/v2/user/pricing/snapshot/`;
export const PRICE_VISIBILITY_API = `${BASE_API}price-visibilities/`;